module.exports = __webpack_public_path__ + "files/07d2799c864bf13bf9a32e04543a8e7c.png";